import React from 'react';
import ReactTable from 'react-table';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import async from 'async';
import { connect } from "react-redux";
import _ from 'lodash';
import DatePicker from 'react-datetime';
import moment from 'moment';
import numeral from 'numeral';
import download from 'downloadjs';

import ReactEcharts from './Chart/ReactEChart';
import MeterModal from './MeterModal';
import ActivityModal from './ActivityModal';
import BillModal from './BillModal';
import BillModalLEC from './BillModalLEC';
import CollectionModal from './CollectionModal';
import TokenModal from './TokenModal';
import TokenModalLEC from './TokenModalLEC';
import TokenModalAPU from './TokenModalAPU';

import MapModal from './MapModal';
import { Select, FormGroup } from 'components/FormElements';
import TablePagination from 'components/HTMLElements/Table/Pagination';
import Translate from 'util/IntlMessages';
import IncmsService from 'services/IncmsService';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import APPCONFIG from 'constants/Config';
import { injectIntl } from "react-intl";

const DisabledInput = ( { children } ) => (
  <div style={{ padding: '6.5px 10px', backgroundColor: '#F0F0F0' }}>{children}</div>
)
const ShadowBox = ( { children, style } ) => (
  <div className="p-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px', ...style }}>
    {children}
  </div>
)

const numeralFormat = ( value ) => value ? numeral( value ).format( '0,0.[00]' ) : 0

class ClientFolder extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      accountData: {},
      accounts: [],
      activeAccount: _.find( _.get( props.channel, 'accounts', [] ), {active: true, account: this.props.activeAccount.account } ),
      movements: [],
      otherInfo: [],
      meterModalOpened: false,
      activityModalOpened: false,
      billModalOpened: false,
      billModalLECOpened: false,
      collectionModalOpened: false,
      mapModalOpened: false,
      tokenModalOpened: false,
      tokenModalLECOpened: false,
      tokenModalAPUOpened: false,
      movementFilterDateFrom: null,
      movementFilterDateTo: null,
      movementFilterType: null,
      otherFilterDateFrom: null,
      otherFilterDateTo: null,
      otherFilterType: null,
      outageInArea: false,
    };

    this.meterDetail = null;
    this.activityData = null;
    this.billDetail = null;
    this.collectionDetail = null;
    this.tokenDetail = null;
    this.getData = this.getData.bind( this );
    this.toggleMeterModal = this.toggleMeterModal.bind( this );
    this.toggleActivityModal = this.toggleActivityModal.bind( this );
    this.toggleMapModal = this.toggleMapModal.bind( this );
    this.filterMovements = this.filterMovements.bind( this );
    this.filterOtherInfo = this.filterOtherInfo.bind( this );

    this.getStatement = this.getStatement.bind( this );
    this.setDateFormat = this.setDateFormat.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    //console.log("Active Account", this.props.activeAccount.account);
    const { activeAccount } = this.state;
    if( !activeAccount ) return;

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    async.parallel( {
      accountData: this.getAccountData.bind( this ),
      outageInArea: this.getOutageInArea.bind( this ),
      otherInfo: this.getOtherInfo.bind( this ),
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      let accounts = _.get( results.accountData, 'OtherAccounts', [] ) || [];
      accounts = _.map( accounts, item => ( { id: item.OtherAccount, account: item.OtherAccount } ) );
      this.setState( {
        accountData: results.accountData,
        accounts: activeAccount ? [activeAccount, ...accounts] : [],
        outageInArea: !!_.get( results.outageInArea, 'imsOutageInArea' ),
        movements: _.get( results.accountData, 'Movements', [] ),
        otherInfo: results.otherInfo,
      } )
    } )
  }

  getAccountData( cb ) {
    IncmsService.getClientFolderData( this.state.activeAccount.account, this.props.locale ? this.props.locale.locale : 'en' )
      .then( ( response ) => {
        if( response.errors ) return cb( response.errors );
        cb( null, response.data )
      } )
  }

  getOutageInArea( cb ) {
    IncmsService.getClientFolderOutageArea( this.state.activeAccount.account )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getOtherInfo( cb ) {
    IncmsService.getOtherInfo()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getMovementDetail( id, type, cb ) {
    const { toggleLoading, toggleAlertError } = this.props;

    toggleLoading( true );
    IncmsService.getClientFolderMovement( id, type )
      .then( ( response ) => {
        toggleLoading( false );
        if( response.errors ) return toggleAlertError( response.errors )

        return cb( response.data )
      } )
  }

  toggleMeterModal( meter ) {
    if( meter ) {
      this.meterDetail = meter;
    } else this.meterDetail = null;
    this.setState( { meterModalOpened: !this.state.meterModalOpened } )
  }

  toggleActivityModal( index ) {
    this.activityData = index >= 0 ? _.get( this.state.accountData, `MyActivity.${index}` ) : null;
    this.setState( { activityModalOpened: !this.state.activityModalOpened } )
  }

  toggleMapModal() {
    this.setState( { mapModalOpened: !this.state.mapModalOpened } )
  }

  toggleBillModal( id ) {
    if( id ) {
      this.getMovementDetail( id, 'bill', ( data ) => {
        this.billDetail = data;
        this.setState( { billModalOpened: !this.state.billModalOpened } )
      } )
    } else {
      this.billDetail = null;
      this.setState( { billModalOpened: !this.state.billModalOpened } )
    }
  }

  toggleBillModalLEC( data ) {
    if( data ) {
        this.billDetail = data;
        this.setState( { billModalLECOpened: !this.state.billModalLECOpened } )
    } else {
      this.billDetail = null;
      this.setState( { billModalLECOpened: !this.state.billModalLECOpened } )
    }
  }

  toggleCollectionModal( id ) {
    if( id ) {
      this.getMovementDetail( id, 'collection', ( data ) => {
        this.collectionDetail = data;
        this.setState( { collectionModalOpened: !this.state.collectionModalOpened } )
      } )
    } else {
      this.collectionDetail = null;
      this.setState( { collectionModalOpened: !this.state.collectionModalOpened } )
    }
  }

  toggleTokenModal( id ) {
    if( id ) {
      this.getMovementDetail( id, 'token', ( data ) => {
        this.tokenDetail = data;
        this.setState( { tokenModalOpened: !this.state.tokenModalOpened } )
      } )
    } else {
      this.tokenDetail = null;
      this.setState( { tokenModalOpened: !this.state.tokenModalOpened } )
    }
  }

  getMovementClass( rowInfo ) {
    const {externalCustomer} = this.props;

    if ( (externalCustomer === 'apu') && ( rowInfo.original.IndPaymentOrBill === 1 || rowInfo.original.IndPaymentOrBill === -1   )  )
      return 'bg-color-movement'
    if ( (externalCustomer !== 'apu') && ( rowInfo.row.MovementType === 'Bill'  || rowInfo.row.MovementType === 'Payment' ) )
      return 'bg-color-movement'
    
    return ''
  }

  toggleTokenModalLEC( data ) {
    // console.log(data)
    if( data ) {
      this.tokenDetail = data;
      this.setState( { tokenModalLECOpened: !this.state.tokenModalLECOpened } )
    
    } else {
      this.tokenDetail = null;
      this.setState( { tokenModalLECOpened: !this.state.tokenModalLECOpened } )
    }
  }

  toggleTokenModalAPU( data ) {
    // console.log(data)
    if( data ) {
      this.tokenDetail = data;
      this.setState( { tokenModalAPUOpened: !this.state.tokenModalAPUOpened } )
    
    } else {
      this.tokenDetail = null;
      this.setState( { tokenModalAPUOpened: !this.state.tokenModalAPUOpened } )
    }
  }

  filterMovements() {
    const { movementFilterDateFrom, movementFilterDateTo, movementFilterType } = this.state;
    const { externalCustomer, dateFormat } = this.props;

    let movements = _.get( this.state.accountData, 'Movements', [] );
    
    if( movementFilterDateFrom ) {
      if (externalCustomer === 'apu'){
        movements = _.filter( movements, item => (
          movementFilterDateFrom.diff( moment( item.Date ) ) <= 0 ) )
      } else {
        movements = _.filter( movements, item => (
          movementFilterDateFrom.diff( moment.unix( item.Date ) ) <= 0 ) )
      }
    };
    if( movementFilterDateTo ) {
      if (externalCustomer === 'apu'){
         movements = _.filter( movements, item => (
           movementFilterDateTo.diff( moment( item.Date ) ) >= 0 ) )
      } else {
         movements = _.filter( movements, item => (
          movementFilterDateTo.diff( moment.unix( item.Date ) ) >= 0 ) )
    
      } 
    };
    if( movementFilterType ) {
      movements = _.filter( movements, { MovementType: movementFilterType } )
    };

    this.setState( { movements } )
  }
  
  filterOtherInfo() {
    const { otherFilterDateFrom, otherFilterDateTo, otherFilterType } = this.state;
    let otherInfo = this.state.otherInfo || [];

    if( otherFilterDateFrom ) {
      otherInfo = _.filter( otherInfo, item => (
        otherFilterDateFrom.diff( moment.unix( item.Date ) ) <= 0 ) )
    }
    if( otherFilterDateTo ) {
      otherInfo = _.filter( otherInfo, item => (
        otherFilterDateTo.diff( moment.unix( item.Date ) ) >= 0 ) )
    }
    if( otherFilterType ) {
      otherInfo = _.filter( otherInfo, { otherType: otherFilterType } )
    }

    this.setState( { otherInfo } )
  }

  getStatement() {
    const { toggleLoading, toggleAlertError } = this.props;
    const { movementFilterDateFrom, movementFilterDateTo, accountData } = this.state;

    toggleLoading( true );
    IncmsService.getStatement( _.get( accountData, 'idPaymentForm' ), {
      from: movementFilterDateFrom ? movementFilterDateFrom.format( dateFormat ) : null,
      to: movementFilterDateTo ? movementFilterDateTo.format( dateFormat ) : null
    } )
      .then( ( response ) => {
        toggleLoading( false );
        if( response.errors ) return toggleAlertError( response.errors )

        download( response.data, 'statemnent.pdf' );
      } )
  }

  setDateFormat( value, isToken = false ){
    const {externalCustomer, dateFormat } = this.props;
    if (externalCustomer === 'lec' || externalCustomer === 'escom') {
      if (isToken){
        return moment(value , "YYYY-MM-DD hh:mm:ss.S" ).format( dateFormat )
      } else {
        return moment.unix( value / 1000 ).format( dateFormat )
      }
    }
    else if (externalCustomer === 'apu') { 
      return moment(value , "YYYY-MM-DD" ).format( dateFormat )
    } else { 
      return moment.unix( value ).format( dateFormat )
    }
  }

  render() {
    const {
      accountData, accounts, activeAccount, movements, otherInfo, movementFilterDateFrom, movementFilterDateTo,
      movementFilterType, meterModalOpened, activityModalOpened, otherFilterDateFrom, otherFilterDateTo,
      otherFilterType,
      billModalOpened, billModalLECOpened, collectionModalOpened, tokenModalOpened, tokenModalLECOpened,
      tokenModalAPUOpened, outageInArea, mapModalOpened
    } = this.state;
    
    const { dateFormat, externalCodes, externalCustomer } = this.props;
    const meters = _.get( accountData, 'ServicesList[0].MeterNumbers', [] );
    const contacts = _.get( accountData, 'Contact', [] );
    const movementTypes = _.chain( _.get( accountData, 'Movements', [] ) )
      .map( item => ( { id: item.MovementType, name: item.MovementType } ) ).uniqBy( 'id' ).value();
    return (
      <div className="client-folder mb-5">
        <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="clientFolder"/>
              </h5>
            </div>
            <div className="col-md-auto d-flex align-items-center">
              {!!outageInArea &&
              <span>
                <i data-tip="Outage" data-for="1" className="fa fa-exclamation-triangle text-danger"
                   style={{ fontSize: 22 }}/>
                <ReactTooltip id="1" place="bottom" type="dark" effect="solid"/>
              </span>
              }
              {_.map( _.get( accountData, 'Tags' ), ( tag, index ) =>
                <span key={index}
                      className={classnames( 'badge text-white text-uppercase ml-2 py-2', {
                        'badge-success': !!tag.Enabled,
                        'badge-secondary': !tag.Enabled,
                      } )}>
                  <span data-tip={tag.Tooltip} data-for={( index + 10 ).toString()}>{tag.Text}</span>
                  <ReactTooltip id={( index + 10 ).toString()} place="bottom" type="dark" effect="solid"/>
                </span>
              )}
            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-9">
              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="account"/>
                    </label>
                    <Select
                      clearable={false}
                      onChange={( value ) => {
                        const account = _.find( accounts, { id: value } );
                        if( account ) {
                          this.setState( { activeAccount: account }, this.getData )
                        }
                      }}
                      options={accounts}
                      className="form-control"
                      labelKey="account"
                      searchable={false}
                      value={activeAccount.id}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="email"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'CustomerEmail', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="office"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'Office', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="name"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'CustomerName', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="phone"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'CustomerPhone', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="credit"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'CreditScore', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="dni"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'Document.DocId', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="address"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'AccountAddress', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <h6><Translate id="contactInfo"/></h6>
              <hr/>
              {contacts && contacts.length ?
                _.map( contacts, ( item, index ) => (
                  <div key={index} className="mb-2">
                    <i className={classnames( 'fa mr-2 text-center', {
                      'fa-mobile': item.Type === 'SMS',
                      'fa-envelope-o': item.Type === 'E-mail',
                      'fa-map-marker': item.Type === 'Address',
                    } )} style={{ fontSize: item.Type === 'SMS' ? 21 : 16, width: 21 }}/>
                    {item.ContactData}
                    {item.CommunicationType ? ' - ' : ''}
                    <span className="text-muted">{item.CommunicationType}</span>
                    {!!item.Principal && <i className="fa fa-check-circle text-primary ml-2"/>}
                  </div>
                ) ) :
                <div className="text-center p-3 text-secondary">
                  <i className="fa fa-exclamation-circle fa-3x"/>
                  <h5 className="font-weight-normal">
                    <Translate id="noContactInfo"/>
                  </h5>
                </div>
              }
            </div>
          </div>
        </div>

        <div className="row m-0">
          <div className="col-12">
            <h5>
              <Translate id="clientActivity"/>
            </h5>
          </div>
        </div>

        <div className="row m-0">
          <div className="col-md-4">
            { ( _.get( accountData, 'AccountBalance' ) && externalCodes) || ( !externalCodes && (  activeAccount.incmsDataobj.contractMask &&  activeAccount.incmsDataobj.contractMask !== 2048 ) ) ?
              <ShadowBox style={{ height: '100%' }}>
                <div className="row px-3 pt-2">
                  <div className="col-md-12">
                    <h6 className="font-weight-medium m-0">
                      <i className="fa fa-dollar color-link mr-1"/> <Translate id="balance"/>
                    </h6>
                    <div className="d-flex my-3 align-items-baseline">
                      <h5 className="m-0">{numeralFormat( _.get( accountData, 'AccountBalance.Balance' ) )}</h5>
                      <p className="mb-0 ml-1">{_.get( accountData, 'Currency' )}</p>
                      {!!_.get( accountData, 'AccountBalance.DueDebt' ) &&
                      <span className="ml-3">
                        <i className="fa fa-exclamation-triangle text-danger"
                           data-for="3"
                           data-tip={_.get( accountData, 'AccountBalance.Tooltip' )}/>
                        <ReactTooltip id="3" place="bottom" type="dark" effect="solid"/>
                      </span>
                      }
                    </div>
                  </div>
                </div>
                
                <div className="row px-3">
                  <div className="col-md-4">
                    <p className="m-0 text-secondary"><Translate id="lastBillDate"/></p>
                    {( externalCustomer !== 'lec' &&  externalCustomer !== 'apu' ) &&
                    <p>{_.get( accountData, 'AccountBalance.LastBillDate' ) ? moment.unix( accountData.AccountBalance.LastBillDate ).format( dateFormat ) : '-'}</p>
                    }
                    {externalCustomer === 'apu' &&
                    <p>{_.get( accountData, 'AccountBalance.LastBillDate' ) ? moment( accountData.AccountBalance.LastBillDate, "YYYY-MM-DD" ).format( dateFormat)  : '-'}</p>
                    }
                    {(externalCustomer === 'lec' || externalCustomer === 'escom') &&
                    <p>{_.get( accountData, 'AccountBalance.LastBillDate' ) ? moment( accountData.AccountBalance.LastBillDate, "YYYY-MM-DD hh:mm:ss.S" ).format( dateFormat ) : '-'}</p>
                    }
                  </div>
                  <div className="col-md-4">
                    <p className="m-0 text-secondary"><Translate id="amount"/></p>
                    <p>{numeralFormat( _.get( accountData, 'AccountBalance.LastBillAmount', '-' ) )} {_.get( accountData, 'Currency' )}</p>
                  </div>
                  <div className="col-md-4">
                    <p className="m-0 text-secondary"><Translate id="lastReading"/></p>
                    <p>{_.get( accountData, 'AccountBalance.LastReading', '-' )}</p>
                  </div>
                </div>
              </ShadowBox> :

              <ShadowBox style={{ height: '100%' }}>
                <div className="row px-3 pt-2">
                  <div className="col-md-12">
                    <h6 className="font-weight-medium m-0">
                      <i className="fa fa-dollar color-link mr-1"/> <Translate id="lastToken"/>
                    </h6>
                    <div className="d-flex my-3 align-items-baseline">
                      <h5 className="m-0">{_.get( accountData, 'AccountBalance.LastTokenAmount', '-' )}</h5>
                      <p className="mb-0 ml-1">{_.get( accountData, 'Currency' )}</p>
                    </div>
                  </div>
                </div>

                <div className="row px-3">
                  <div className="col-md-6">
                    <p className="m-0 text-secondary"><Translate id="date"/></p>
                    {externalCustomer !== 'lec' &&
                    <p>{_.get( accountData, 'AccountBalance.LastTokenDate' ) ? moment.unix( accountData.AccountBalance.LastTokenDate ).format( dateFormat ) : '-'}</p>
                    }
                    {(externalCustomer === 'lec' || externalCustomer === 'escom') &&
                    <p>{_.get( accountData, 'AccountBalance.LastTokenDate' ) ? moment( accountData.AccountBalance.LastTokenDate, "YYYY-MM-DD hh:mm:ss.S" ).format( dateFormat ) : '-'}</p>
                    }
                  </div>
                  <div className="col-md-6">
                    <p className="m-0 text-secondary"><Translate id="token"/></p>
                    <p>{_.get( accountData, 'AccountBalance.LastToken' ) ? accountData.AccountBalance.LastToken.match( /.{1,4}/g ).join( '.' ) : '-'}</p>
                  </div>
                </div>
              </ShadowBox>
            }
          </div>

          <div className="col-md-4">
            <ShadowBox style={{ height: '100%' }}>
              <div className="row px-3 pt-2 align-items-center">
                <div className="col-md">
                  <h6 className="font-weight-medium m-0">
                    <i className="fa fa-file-text-o color-link mr-1"/> <Translate id="contract"/>
                  </h6>
                </div>
                {accountData && accountData.ServiceXCoord && accountData.ServiceYCoord && externalCustomer != 'apu' ?
                  <div className="col-md-auto">
                    <a
                      onClick={this.toggleMapModal}
                      // href={`http://www.google.com/maps/place/${accountData.ServiceXCoord},${accountData.ServiceYCoord}`}
                      // target="_blank"
                      className="color-link pointer">
                      <Translate id="location"/>
                      <i className="fa fa-map-marker ml-2" style={{ fontSize: 20 }}/>
                    </a>
                  </div> : null
                }
              </div>
              <div className="row px-3 align-items-center">
                <div className="col-md">
                  {externalCustomer !== 'lec' &&
                  <h5>{_.get( accountData, 'Contract.Fare', '-' )}</h5>
                  }
                  {(externalCustomer === 'lec' || externalCustomer === 'escom') &&
                  <h6>{_.get( accountData, 'ServicesList[0].Fare', '-' )}</h6>
                  }
                  

                  <div className="row px-3">
                    <div className="col-md-6 pl-0">
                      <p className="m-0 text-secondary"><Translate id="status"/></p>
                      {externalCustomer !== 'lec' &&
                      <p>{_.get( accountData, 'AccountStatus', '-' )}</p>
                      }
                      {(externalCustomer === 'lec' || externalCustomer === 'escom') &&
                      <p>{_.get( accountData, 'ServicesList[0].Status', '-' )}</p>
                      }
                    </div>
                    <div className="col-md-6 pr-0">
                      <p className="m-0 text-secondary"><Translate id="meter"/></p>
                      <p>
                        {_.map( meters, ( item, index ) => (
                            <span key={index}>
                              <span onClick={() => this.toggleMeterModal( item )}
                                    className="color-link pointer">{item.SerialNumber}</span>
                              {index < meters.length - 1 ? ', ' : ''}
                            </span>
                          )
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-auto d-flex flex-column">
                  <div>
                    <span
                      data-tip={_.get( accountData, 'MyActivity.Anomalies.TooltipBillAnomalies' ) || ''}
                      data-for="BillAnomalies"
                      className={classnames( 'badge text-white text-uppercase mb-2 py-2', {
                        'badge-success': !!_.get( accountData, 'MyActivity.Anomalies.BillAnomalies' ),
                        'badge-secondary': !_.get( accountData, 'MyActivity.Anomalies.BillAnomalies' ),
                      } )}>
                      <Translate id="billAnomalies"/>
                    </span>
                    <ReactTooltip id="BillAnomalies" place="bottom" type="dark" effect="solid"/>
                  </div>
                  <div>
                    <span
                      data-tip={_.get( accountData, 'MyActivity.Anomalies.TooltipReadAnomalies' ) || ''}
                      data-for="TooltipReadAnomalies"
                      className={classnames( 'badge text-white text-uppercase py-2', {
                        'badge-success': !!_.get( accountData, 'MyActivity.Anomalies.ReadAnomalies' ),
                        'badge-secondary': !_.get( accountData, 'MyActivity.Anomalies.ReadAnomalies' ),
                      } )}>
                    <Translate id="readAnomalies"/>
                  </span>
                    <ReactTooltip id="TooltipReadAnomalies" place="bottom" type="dark" effect="solid"/>
                  </div>
                </div>
              </div>
            </ShadowBox>
          </div>

          <div className="col-md-4">
            <ShadowBox style={{ height: '100%' }}>
              <div className="row px-3 pt-2">
                <div className="col-md-12">
                  <h6 className="font-weight-medium m-0">
                    <i className="fa fa-list-ul color-link mr-1"/> <Translate id="myActivity"/>
                  </h6>
                </div>
              </div>

              <div className="row px-3">
                {_.map( _.get( accountData, 'MyActivity', [] ), ( items, index ) =>
                  _.keys( items )[0] && _.values( items )[0] ?
                    <div className="col-md-4 mt-3" key={index}>
                      <p className="m-0 text-secondary"><Translate id={_.keys( items )[0]}/></p>
                      <p onClick={() => _.values( items )[0].length > 0 ? this.toggleActivityModal( index ) : {}}
                         className={classnames( {
                           'color-link pointer': _.values( items )[0].length > 0
                         } )}>{_.values( items )[0].length}</p>
                    </div> : null
                )}
              </div>
            </ShadowBox>
          </div>
        </div>

        <div className="row mx-0 mt-5">
          <div className="col-12">
            <ShadowBox>
              <h6 className="font-weight-medium mt-0">
                <Translate id="consumptions"/>
              </h6>
              <ReactEcharts options={{
                color: ['#DE2F2F', '#87BEE6', '#2E6C99'],
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    crossStyle: {
                      color: '#999'
                    }
                  }
                },
                dataZoom: [
                  {
                    show: true,
                    realtime: true,
                    // startValue: _.get(graph, `${graph.length - 5}.DateMMYYYY`),
                    xAxisIndex: [0]
                  },
                ],
                legend: {
                  data: [
                    this.props.intl.formatMessage( { id: 'pendingAmount' } ),
                    this.props.intl.formatMessage( { id: 'billingAmount' } ),
                    this.props.intl.formatMessage( { id: 'consumption' } )
                  ]
                },
                xAxis: [
                  {
                    type: 'category',
                    data: _.map(_.reverse(_.map( _.get( accountData, 'Movements', [] ), 'Date' )), (item) => ( moment( item).format('YYYY-MM-DD'))),
                    axisPointer: {
                      type: 'shadow'
                    }
                  }
                ],
                yAxis: [
                  {
                    type: 'value',
                    name: externalCustomer ==='apu' ? _.get( accountData, 'Currency' ): _.get( accountData, 'Graph.MainConsumptionUnits', 'Kw/h' ),
                    min: 0,
                    //interval: 50,
                  },
                  {
                    type: 'value',
                    name: externalCustomer ==='apu' ? _.get( accountData, 'Graph.MainConsumptionUnits', 'Kw/h' ) : _.get( accountData, 'Currency' ),
                    min: 0,
                    //  interval: 100,
                  }
                ],
                series: [
                  {
                    name: this.props.intl.formatMessage( { id: 'pendingAmount' } ),
                    type: 'bar',
                    stack: 'one',
                    data: _.reverse(_.map( _.get( accountData, 'Movements' ) ?_.get( accountData, 'Movements', [] ) : _.get( accountData, 'Movements', [] ) , (item) => (item.Amount - item.PaymentAmount) )),
                  },
                  {
                    name: this.props.intl.formatMessage( { id: 'billingAmount' } ),
                    type: 'bar',
                    stack: 'one',
                    barMaxWidth: 40,
                    data: _.reverse(_.map( _.get( accountData, 'Movements' ) ? _.get( accountData, 'Movements', [] ) : _.get( accountData, 'Movements', [] ) , 'Amount' )),
                  },
                  {
                    name: this.props.intl.formatMessage( { id: 'consumption' } ),
                    type: 'line',
                    yAxisIndex: 1,
                    data: _.reverse(_.map( _.get( accountData, 'Movements' ) ? (_.get( accountData, 'Movements', [] )) : (_.get( accountData, 'Movements', [] ))  , 'Consumption' ))
                  }
                ]
              }}/>
            </ShadowBox>
          </div>
        </div>

        <div className="row mx-0 mt-5">
          <div className="col-12" id="account-details">
            <ShadowBox>
              <h6 className="font-weight-medium mt-0">
                <Translate id="movements"/>
              </h6>

              <div className="row">
                <div className="col-md-5">
                  <div className="row">
                    <div className="col-12">
                      <label><Translate id="date"/></label>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <FormGroup containerClass="col-md" className="m-0">
                      <div className="input-group">
                        <DatePicker
                          locale={this.props.locale ? this.props.locale.locale : 'en'}
                          dateFormat={dateFormat}
                          timeFormat={false}
                          inputProps={{
                            className: 'form-control bg-color-white',
                            readOnly: true
                          }}
                          clearable
                          closeOnSelect={true}
                          value={movementFilterDateFrom ? moment( movementFilterDateFrom ).format( dateFormat ) : ''}
                          onChange={( value ) => this.setState( { movementFilterDateFrom: value }, this.filterMovements )}
                        />
                        {movementFilterDateFrom ?
                          <span className="input-group-addon fa fa-times pointer"
                                onClick={() => this.setState( { movementFilterDateFrom: null }, this.filterMovements )}/> : null
                        }
                      </div>
                    </FormGroup>
                    <div className="col-md-auto">
                      <Translate id="to"/>
                    </div>
                    <FormGroup containerClass="col-md" className="m-0">
                      <div className="input-group">
                        <DatePicker
                          locale={this.props.locale ? this.props.locale.locale : 'en'}
                          dateFormat={dateFormat}
                          timeFormat={false}
                          inputProps={{
                            className: 'form-control bg-color-white',
                            readOnly: true
                          }}
                          clearable
                          closeOnSelect={true}
                          value={movementFilterDateTo ? moment( movementFilterDateTo ).format( dateFormat ) : ''}
                          onChange={( value ) => this.setState( { movementFilterDateTo: value }, this.filterMovements )}
                        />
                        {movementFilterDateTo ?
                          <span className="input-group-addon fa fa-times pointer"
                                onClick={() => this.setState( { movementFilterDateTo: null }, this.filterMovements )}/> : null
                        }
                      </div>
                    </FormGroup>
                  </div>
                </div>

                <FormGroup containerClass="col-md-3" className="m-0">
                  <label><Translate id="movementType"/></label>
                  <Select clearable
                          placeholder={<Translate id="placeHolderSelect"/>}
                          noResultsText={<Translate id="noDataFound"/>}
                          className="form-control"
                          onChange={( value ) => {
                            this.setState( { movementFilterType: value }, this.filterMovements )
                          }}
                          options={movementTypes}
                          searchable={false}
                          value={movementFilterType}/>
                </FormGroup>
                {_.get( accountData, 'idPaymentForm' ) ?
                  <div className="col-md">
                    <button className="btn btn-secondary" style={{ marginTop: 27 }} onClick={this.getStatement}>
                      <Translate id="statement"/>
                    </button>
                  </div> : null}
              </div>

              <ReactTable className="app-table -highlight app-table-white mb-5"
                          data={movements}
                          defaultPageSize={10}
                          minRows={0}
                          defaultSorted={[{ id: 'Date', desc: true }]}
                          resizable={false}
                          showPaginationBottom={false}
                          showPaginationTop
                          previousText={<Translate id='Previous'/>}
                          nextText={<Translate id='Next'/>}
                          loadingText={<Translate id='Loading'/>}
                          noDataText={<Translate id='NoRowsFound'/>}
                          pageText={<Translate id='Page'/>}
                          ofText={<Translate id='of'/>}
                          rowsText={<Translate id='rows'/>}
                          columns={[
                            {
                              Header: <Translate id="movementType"/>, accessor: 'MovementType',
                              Cell: props => (
                                <span>
                                  {externalCustomer === 'apu' ?
                                    <i style={{ fontSize: 20 }}
                                      className={classnames( 'fa mr-2', {
                                        'fa-angle-up text-danger': props.original.IndPaymentOrBill === 1,
                                        'fa-angle-down text-success': props.original.IndPaymentOrBill === -1,
                                      } )}/>
                                    : 
                                    <i style={{ fontSize: 20 }}
                                      className={classnames( 'fa mr-2', {
                                        'fa-angle-up text-danger': props.original.MovementType === 'Bill',
                                        'fa-angle-down text-success': props.original.MovementType === 'Payment',
                                      } )}/>
                                  }
                                  {props.value}
                                </span>
                              )
                            },
                            {
                              Header: <Translate id="date"/>,
                              accessor: 'Date',
                              Cell: props => this.setDateFormat(props.value, props.original.type === 'Token'),
                            },
                            { Header: <Translate id="DocNumber"/>, accessor: 'DocNumber' },
                            { Header: <Translate id="Amount"/>, accessor: 'Amount', Cell: props => ( numeralFormat( props.value ) ) },
                            { Header: <Translate id="Consumption"/>,id: "consumption", accessor: c => c.Consumption },
                            { Header: <Translate id="Balance"/>, accessor: 'Balance', Cell: props => ( numeralFormat( props.value ) ) },
                            {
                              accessor: 'UniqeID',
                              maxWidth: 80,
                              sortable: false,
                              Cell: props => (
                                <div>
                                  {props.original.type === 'Token' &&
                                  <i style={{ fontSize: 20 }} className="fa fa-info-circle color-link pointer"
                                     onClick={() => this.toggleTokenModalLEC( props.original )}/>}
                                  {props.original.type === 'Bill' &&
                                  <i style={{ fontSize: 20 }} className="fa fa-info-circle color-link pointer"
                                     onClick={() => this.toggleBillModalLEC( props.original )}/>}
                                  { ( (this.props.externalCustomer ==='kplc' &&  props.original.MovementType === 'Bill')  
                                    || (this.props.externalCustomer ==='apu' &&  props.original.IndPaymentOrBill === 1) )  &&
                                  <i style={{ fontSize: 20 }} className="fa fa-info-circle color-link pointer"
                                     onClick={() => this.toggleBillModal( props.value )}/>}
                                  { ( (this.props.externalCustomer ==='kplc' &&  props.original.MovementType === 'Payment') )  &&
                                    <i style={{ fontSize: 20 }} className="fa fa-info-circle color-link pointer"
                                       onClick={() => this.toggleCollectionModal( props.value )}/>
                                  }
                                  { ( (this.props.externalCustomer ==='apu' &&  props.original.IndPaymentOrBill === -1) )  &&
                                    <i style={{ fontSize: 20 }} className="fa fa-info-circle color-link pointer"
                                       onClick={() => this.toggleTokenModalAPU( props.original )}/>
                                  }
                                  { ( (this.props.externalCustomer ==='kplc' &&  props.original.MovementType === 'Token')  
                                     )  &&
                                    <i style={{ fontSize: 20 }} className="fa fa-info-circle color-link pointer"
                                       onClick={() => this.toggleTokenModal( props.value )}/>
                                  }
                                </div>
                              )
                            },
                          ]}
                          PaginationComponent={( props ) =>
                            <TablePagination {...props} showPageSizeOptions={false}/>
                          }
                          getTrProps={( state, rowInfo ) => {
                            return {
                              
                              className: this.getMovementClass( rowInfo )
                              
                            };
                          }}
              />
            </ShadowBox>
          </div>
        </div>

        {(externalCustomer === 'lec' || externalCustomer === 'escom') && (
        <div className="row mx-0 mt-5">
          <div className="col-12" id="account-details">
            <ShadowBox>
              <h6 className="font-weight-medium mt-0">
                <Translate id="otherInformation"/>
              </h6>

              <ReactTable className="app-table -highlight app-table-white mb-5"
                          data={otherInfo}
                          defaultPageSize={10}
                          minRows={0}
                          defaultSorted={[{ id: 'date', desc: true }]}
                          resizable={false}
                          showPaginationBottom={false}
                          showPaginationTop
                          previousText={<Translate id='Previous'/>}
                          nextText={<Translate id='Next'/>}
                          loadingText={<Translate id='Loading'/>}
                          noDataText={<Translate id='NoRowsFound'/>}
                          pageText={<Translate id='Page'/>}
                          ofText={<Translate id='of'/>}
                          rowsText={<Translate id='rows'/>}
                          columns={[
                            { Header: <Translate id='Type'/>, accessor: 'type' },
                            {
                              Header: <Translate id='date'/>,
                              accessor: 'date',
                              Cell: props => this.setDateFormat(props.value, true),
                            },
                            { Header: 'Token', accessor: 'token' },
                            
  

                          ]}
                          PaginationComponent={( props ) =>
                            <TablePagination {...props} showPageSizeOptions={false}/>
                          }

              />
            </ShadowBox>
          </div>
        </div>
        )}

        {meterModalOpened && !!this.meterDetail &&
        <MeterModal
          data={this.meterDetail}
          open={meterModalOpened}
          onClose={() => this.toggleMeterModal()}/>
        }

        {activityModalOpened &&
        <ActivityModal
          data={this.activityData}
          open={activityModalOpened}
          onClose={() => this.toggleActivityModal()}/>
        }

        {billModalOpened &&
        <BillModal
          data={this.billDetail}
          open={billModalOpened}
          onClose={() => this.toggleBillModal()}/>
        }

        {billModalLECOpened &&
        <BillModalLEC
          data={this.billDetail}
          open={billModalLECOpened}
          onClose={() => this.toggleBillModalLEC()}/>
        }

        {collectionModalOpened &&
        <CollectionModal
          data={this.collectionDetail}
          open={collectionModalOpened}
          onClose={() => this.toggleCollectionModal()}/>
        }

        {tokenModalOpened &&
        <TokenModal
          data={this.tokenDetail}
          open={tokenModalOpened}
          onClose={() => this.toggleTokenModal()}/>
        }

        {tokenModalLECOpened &&
        <TokenModalLEC
          data={this.tokenDetail}
          open={tokenModalLECOpened}
          onClose={() => this.toggleTokenModalLEC()}/>
        }
        {tokenModalAPUOpened &&
        <TokenModalAPU
          data={this.tokenDetail}
          open={tokenModalAPUOpened}
          onClose={() => this.toggleTokenModalAPU()}/>
        }
        {mapModalOpened &&
        <MapModal
          data={`https://www.google.com/maps/embed/v1/place?q=${accountData.ServiceXCoord},${accountData.ServiceYCoord}&key=${APPCONFIG.mapKey}`}
          open={mapModalOpened}
          onClose={() => this.toggleMapModal()}/>
        }
      </div>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCodes: state.settings.externalCodes,
  externalCustomer: state.settings.externalCustomer,
  activeAccount: state.channelDetail.activeAccount,

} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );
export default injectIntl( connect( mapStateToProps, mapDispatchToProps )( ClientFolder ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/index.js